import Pagination from "../../api/v2/models/pagination"

export default Pagination
